import Link from 'next/link';
import { getLanguageDataByCode } from '@/i18n/language-data';
import { localizedPublicPath } from '@/i18n/config';

const SUPPORT_EMAIL = 'support@shelterfuture.com';

export default function SiteFooter({ languageCode }: { languageCode: string }) {
  const langData = getLanguageDataByCode(languageCode);
  const discoverLabel = languageCode === 'zh-CN'
    ? '境谜 Scenigma · 海龟汤在线'
    : '境谜 Scenigma';

  return (
    <footer className="border-t border-border/60 bg-background/70 px-5 py-5 sm:px-8 lg:px-10">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
        <Link
          href={localizedPublicPath('/discover', languageCode)}
          className="leading-5 transition-colors hover:text-foreground"
        >
          {discoverLabel}
        </Link>
        <nav aria-label="Legal and support" className="flex flex-wrap items-center gap-x-4 gap-y-2">
          {languageCode === 'zh-CN' && (
            <Link
              href={localizedPublicPath('/guide/haiguitang', languageCode)}
              className="transition-colors hover:text-foreground"
            >
              海龟汤指南
            </Link>
          )}
          <Link
            href={localizedPublicPath('/support', languageCode)}
            className="transition-colors hover:text-foreground"
          >
            {languageCode === 'zh-CN' ? '客服与帮助' : 'Support'}
          </Link>
          <Link
            href={localizedPublicPath('/terms', languageCode)}
            className="transition-colors hover:text-foreground"
          >
            {langData.settings_terms_of_service}
          </Link>
          <Link
            href={localizedPublicPath('/privacy', languageCode)}
            className="transition-colors hover:text-foreground"
          >
            {langData.settings_privacy_policy}
          </Link>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="transition-colors hover:text-foreground"
          >
            {SUPPORT_EMAIL}
          </a>
        </nav>
      </div>
    </footer>
  );
}
